import { render, staticRenderFns } from "./InlineChildOverviewWrapper.vue?vue&type=template&id=6f8e0d2e&"
import script from "./InlineChildOverviewWrapper.vue?vue&type=script&lang=js&"
export * from "./InlineChildOverviewWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports